/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/healthcheck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Check API system status */
        get: operations["GetHealthcheck"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/models": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List of models available to affiliate */
        get: operations["GetApiModels"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Affiliate offer details */
        get: operations["GetApiV2Offers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Affiliate offer details */
        get: operations["GetApiV2OffersAdvertModel"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/advertiser": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Offer advertiser details */
        get: operations["GetApiV2OffersAdvertModelAdvertiser"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/cpa-rates": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get user's offers cpa rules and can use for preview */
        get: operations["GetApiV2OffersAdvertModelCpaRates"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/cpa-triggers": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get user's offers cpa triggers for aff cabinet */
        get: operations["GetApiV2OffersAdvertModelCpaTriggers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/revenue-rated-view": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get user's offers revenue levels */
        get: operations["GetApiV2OffersAdvertModelRevenueRatedView"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/activation": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Offer activation status */
        get: operations["GetApiV2OffersAdvertModelActivation"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/activations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Offer activation status */
        get: operations["GetApiV2OffersActivations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/traffic-sources": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Send traffic sources to verification */
        post: operations["PostApiV2OffersAdvertModelTrafficSources"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/marketing-rules-accept": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Accept marketing rules */
        post: operations["PostApiV2OffersAdvertModelMarketingRulesAccept"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/favorite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Add offer into favourite list */
        post: operations["PostApiV2OffersFavorite"];
        /** Remove offer from favourite list */
        delete: operations["DeleteApiV2OffersFavorite"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List of advertisers available to affiliate */
        get: operations["GetApiAdvertisers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser details */
        get: operations["GetApiAdvertisersId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate-advertisers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Get advertiser settings (backlink) for affiliate */
        get: operations["GetApiAffiliateAdvertisersId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Change advertiser settings (backlink) for affiliate */
        patch: operations["PatchApiAffiliateAdvertisersId"];
        trace?: never;
    };
    "/api/advertisers/{id}/models": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser models */
        get: operations["GetApiAdvertisersIdModels"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers/{id}/attributes": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser attributes */
        get: operations["GetApiAdvertisersIdAttributes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers/{id}/countries": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser countries */
        get: operations["GetApiAdvertisersIdCountries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/rules/{section}/{locale}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
                section: string;
                locale: string;
            };
            cookie?: never;
        };
        /** Get section content for locale */
        get: operations["GetOfferRule"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/rules": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get offer rules */
        get: operations["GetOfferRules"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/offers/loyalty-levels": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get user's loyalty program levels */
        get: operations["GetApiOffersLoyaltyLevels"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        OfferRules: {
            generalRestrictions?: string;
            appsGuidelines?: string;
            trafficTypes?: string;
            negativeKeywords?: string;
            marketingGuidelines?: string;
            paymentTerms?: string;
        };
        /** @enum {string} */
        OfferRuleSectionType: "generalRestrictions" | "marketingGuidelines" | "trafficTypes" | "negativeKeywords" | "appsGuidelines" | "paymentTerms";
        /** @enum {string} */
        OfferTrafficSourcesStatus: "not_verified" | "pending" | "approved" | "rejected";
        OfferCpaCategoryWeight: number;
        OfferTrafficSources: string[];
        ModelsCollection: {
            data: {
                id: string;
                name: string;
            }[];
        };
        OfferPaymentStatus: components["schemas"]["SwitcherWithSuspension"];
        OfferTrafficStatus: components["schemas"]["SwitcherWithSuspension"];
        /** @enum {string} */
        SwitcherWithSuspension: "enabled" | "disabled" | "suspended";
        /** @enum {string} */
        OfferCpaPlatform: "mobile" | "desktop";
        OfferActivation: {
            trafficStatus: components["schemas"]["OfferTrafficStatus"];
            paymentsStatus: components["schemas"]["OfferPaymentStatus"];
            accountConditions: (components["schemas"]["KycPassedCondition"] | components["schemas"]["MarketingRulesAcceptedCondition"] | components["schemas"]["TrafficSourcesVerifiedCondition"])[];
            paymentsConditions: (components["schemas"]["ActiveTradersAttractedCondition"] | components["schemas"]["AntiFraudChecksCondition"])[];
        };
        KycPassedCondition: components["schemas"]["BaseCondition"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "kycPassed";
        };
        MarketingRulesAcceptedCondition: components["schemas"]["BaseCondition"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "marketingRulesAccepted";
        };
        AntiFraudChecksCondition: components["schemas"]["BaseCondition"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "antiFraudChecks";
        };
        ActiveTradersAttractedCondition: components["schemas"]["BaseCondition"] & {
            expectedCnt: number;
            actualCnt: number;
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "activeTradersAttracted";
        };
        TrafficSourcesVerifiedCondition: components["schemas"]["BaseCondition"] & {
            ticketId: string;
            trafficSources: string[];
            trafficSourcesStatus: components["schemas"]["OfferTrafficSourcesStatus"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "trafficSourcesVerified";
        };
        BaseCondition: {
            type: string;
            isSatisfied: boolean;
        };
        /** @deprecated */
        OfferCpaAffiliateRatesCollection: {
            categories: components["schemas"]["OfferCpaAffiliateCategory"][];
            data: components["schemas"]["OfferCpaAffiliateRate"][];
        };
        OfferCpaAffiliateCategory: {
            name: string;
            weight: components["schemas"]["OfferCpaCategoryWeight"];
            minDepositAmount?: components["schemas"]["MoneyOld"];
        };
        /** @deprecated */
        OfferCpaAffiliateRate: {
            country: components["schemas"]["Country"];
            platform: components["schemas"]["OfferCpaPlatform"];
            category: components["schemas"]["OfferCpaAffiliateCategory"];
            price: components["schemas"]["MoneyOld"];
        };
        /** @enum {string} */
        OfferRulesConfigRulesMode: "editor" | "plain";
        /** @enum {string} */
        OfferRateConfigDynamicRatesMode: "with_progress" | "without_progress";
        /** @enum {string} */
        OfferRateConfigRatesDescriptionMode: "plain" | "editor";
        /** @enum {string} */
        OfferRateConfigRateShortMode: "plain" | "dynamic";
        Advertiser: {
            id: number;
            name: string;
            alias: string;
            shortDescription: string;
            description: string;
            website: string;
            links: components["schemas"]["AdvertiserLinks"];
            logo: string;
            restrictionGrade: number;
            regions: string[];
            platforms: string[];
            theme: string[];
        };
        AdvertiserAttribute: {
            title: string;
            type: string;
            value: string;
        };
        AdvertiserLinks: {
            type: string;
            url: string;
        }[];
        AffiliateAdvertiser: {
            affId: number;
            advertiserId: number;
            backlinkUrl: string;
        };
        AffiliateAdvertiserPatch: {
            backlinkUrl?: string;
        };
        OfferRuleSection: {
            section: components["schemas"]["OfferRuleSectionType"];
            is_populated: boolean;
        };
        Offer: {
            id: number;
            /** @enum {string} */
            availability: "available" | "unavailable";
            /**
             * @deprecated
             * @description use advertiser field
             */
            advertiserId: number;
            advertiser: components["schemas"]["Advertiser"];
            restrictionGrade: number;
            icon: string;
            /** @deprecated */
            name: string;
            shortName: string;
            regions: string[];
            model: string;
            rate: string;
            paymentsStatus: components["schemas"]["OfferPaymentStatus"];
            trafficStatus: components["schemas"]["OfferTrafficStatus"];
            rateDescription: string;
            rules: components["schemas"]["OfferRules"];
            links: components["schemas"]["AdvertiserLinks"];
            marketingRulesAccepted: boolean;
            isFavorite: boolean;
            isTrial: boolean;
            ftdCount: number;
            version: components["schemas"]["OfferVersion"];
            ratesConfig?: components["schemas"]["OfferRatesConfig"];
            rulesConfig?: components["schemas"]["OfferRulesConfig"];
        };
        OfferV2: {
            id: number;
            /** @enum {string} */
            availability: "available" | "unavailable";
            isFavourite: boolean;
            advertiserId: number;
            /** @deprecated */
            name: string;
            shortName: string;
            model: string;
            rate: string;
            paymentsStatus: components["schemas"]["OfferPaymentStatus"];
            trafficStatus: components["schemas"]["OfferTrafficStatus"];
            rules: components["schemas"]["OfferRules"];
            marketingRulesAccepted: boolean;
            isTrial: boolean;
            ftdCount: number;
            rateShort?: components["schemas"]["OfferRateConfigRateShort"];
            version: components["schemas"]["OfferVersion"];
        };
        OfferAdvertiser: {
            id: number;
            name: string;
            description: string;
            logo: string;
            website: string;
            restrictionGrade: number;
            platforms: string[];
            theme: string[];
            regions: string[];
        };
        OffersActivationsCollection: {
            data: components["schemas"]["OffersActivationsCollectionItem"][];
        };
        OffersActivationsCollectionItem: {
            offerId: number;
            paymentConditions: components["schemas"]["OfferActivation"];
        };
        AdvertisersCollection: {
            data: components["schemas"]["Advertiser"][];
        };
        AdvertiserAttributesCollection: {
            data: components["schemas"]["AdvertiserAttribute"][];
        };
        AdvertiserCountriesCollection: {
            data: components["schemas"]["Country"][];
        };
        OfferCpaTriggersResponseV2: {
            triggers: components["schemas"]["OfferCpaTriggerV2"][];
        };
        OfferCpaTriggerV2: {
            countries: components["schemas"]["CountryCode"][];
            platforms: components["schemas"]["OfferCpaPlatform"][];
            deposit_amount: components["schemas"]["MoneyV4"];
            default_price: components["schemas"]["MoneyV4"];
        };
        OfferRevenueRatedView: {
            /** Format: double */
            current_revenue_share_percent: number;
            /** Format: int64 */
            current_ftd_count: number;
            levels: components["schemas"]["OfferRevenueRatedViewLevel"][];
        };
        OfferRevenueRatedViewLevel: {
            /** Format: double */
            revenue_share_percent: number;
            /** Format: int64 */
            ftd_count: number;
        };
        OfferFavourite: {
            offerId: number;
        };
        OfferActivationTrafficSourcesPost: {
            sources: components["schemas"]["OfferTrafficSources"];
        };
        OffersCollectionV2: {
            data: components["schemas"]["OfferV2"][];
        };
        OfferRatesConfig: {
            rate_short: components["schemas"]["OfferRateConfigRateShort"];
            rates_description: components["schemas"]["OfferRateConfigRatesDescription"];
            dynamic_rates: components["schemas"]["OfferRateConfigDynamicRates"];
        };
        OfferRulesConfig: {
            rules: components["schemas"]["OfferRulesConfigRules"];
        };
        OfferRulesConfigRules: {
            mode: components["schemas"]["OfferRulesConfigRulesMode"];
        };
        OfferRateConfigRateShort: {
            enabled: boolean;
            mode: components["schemas"]["OfferRateConfigRateShortMode"];
            text: string;
        };
        OfferRateConfigRatesDescription: {
            enabled: boolean;
            mode: components["schemas"]["OfferRateConfigRatesDescriptionMode"];
            text: string;
        };
        OfferRateConfigDynamicRates: {
            enabled: boolean;
            mode: components["schemas"]["OfferRateConfigDynamicRatesMode"];
        };
        /** @enum {string} */
        OfferVersion: "v1" | "v2";
        OfferRulesResponse: {
            data: components["schemas"]["OfferRule"][];
        };
        OfferRuleItem: {
            section: components["schemas"]["OfferRuleSectionType"];
            body: string;
        };
        OfferRule: {
            locale: string;
            sections: components["schemas"]["OfferRuleSection"][];
        };
        LoyaltyLevels: {
            /** Format: int64 */
            current_ftd_count: number;
            levels: components["schemas"]["LoyaltyLevel"][];
        };
        LoyaltyLevel: {
            id: number;
            name: string;
            /** Format: int64 */
            ftd_count: number;
        };
        ErrorField: {
            /** @description translation key of error */
            key?: string;
            params?: {
                [key: string]: string;
            };
        };
        ErrorItem: {
            _global?: components["schemas"]["ErrorField"];
            fields?: {
                [key: string]: components["schemas"]["ErrorField"];
            };
        };
        Error: {
            error?: components["schemas"]["ErrorItem"];
        };
        HealthcheckResponse: {
            alive: boolean;
        };
        /** @deprecated */
        MoneyOld: {
            amount: string;
        };
        Country: {
            name: string;
            code: string;
        };
        CountryCode: string;
        /**
         * Format: double
         * @deprecated
         */
        MoneyAmount: number;
        /** @deprecated */
        MoneyV4: {
            amount: components["schemas"]["MoneyAmount"];
            currency: string;
        };
    };
    responses: {
        /** @description Unexpected Error */
        DefaultErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Not Found */
        Default404ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Bad Request */
        Default400ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Unauthorized */
        Default401ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Forbidden */
        Default403ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
    };
    parameters: {
        /** @description for favourite list */
        OffersFilterByIsFavourite: boolean;
        OffersFilterByAvailabilityStatus: "unavailable" | "available";
        OffersFilterByAdvertiserIds: number[];
        OffersFilterByRegions: string[];
        /**
         * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
         * @example exnova_revenue
         */
        AdvertModel: string;
        /** @description The id of the advertiser */
        AdvertiserId: number;
        OffersFilterByModels: string[];
        /** @description Locale information */
        LocaleId: string;
        /** @description The name of the section */
        SectionId: components["schemas"]["OfferRuleSectionType"];
        /** @description The id of the offer */
        OfferId: number;
        OffersCpaRequiredFilterByPlatform: components["schemas"]["OfferCpaPlatform"];
        FilterByCountries: string[];
    };
    requestBodies: {
        OfferActivationTrafficSourcesPostBody: {
            content: {
                "application/json": components["schemas"]["OfferActivationTrafficSourcesPost"];
            };
        };
        OfferIdPostBody: {
            content: {
                "application/json": components["schemas"]["OfferFavourite"];
            };
        };
        AffiliateAdvertiserPatchBody: {
            content: {
                "application/json": components["schemas"]["AffiliateAdvertiserPatch"];
            };
        };
    };
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    GetHealthcheck: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HealthcheckResponse"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiModels: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModelsCollection"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2Offers: {
        parameters: {
            query?: {
                /** @description for favourite list */
                isFavourite?: components["parameters"]["OffersFilterByIsFavourite"];
                status?: components["parameters"]["OffersFilterByAvailabilityStatus"];
                advertiserIds?: components["parameters"]["OffersFilterByAdvertiserIds"];
                modelId?: components["parameters"]["OffersFilterByModels"];
                regions?: components["parameters"]["OffersFilterByRegions"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OffersCollectionV2"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModel: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Offer"];
                };
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelAdvertiser: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferAdvertiser"];
                };
            };
            400: components["responses"]["Default400ErrorResponse"];
            401: components["responses"]["Default401ErrorResponse"];
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelCpaRates: {
        parameters: {
            query: {
                platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
                countries?: components["parameters"]["FilterByCountries"];
            };
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferCpaAffiliateRatesCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelCpaTriggers: {
        parameters: {
            query: {
                platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
                countries?: components["parameters"]["FilterByCountries"];
            };
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferCpaTriggersResponseV2"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelRevenueRatedView: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferRevenueRatedView"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelActivation: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferActivation"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersActivations: {
        parameters: {
            query?: {
                advertiserIds?: components["parameters"]["OffersFilterByAdvertiserIds"];
                modelId?: components["parameters"]["OffersFilterByModels"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OffersActivationsCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PostApiV2OffersAdvertModelTrafficSources: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: components["requestBodies"]["OfferActivationTrafficSourcesPostBody"];
        responses: {
            /** @description Success */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PostApiV2OffersAdvertModelMarketingRulesAccept: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PostApiV2OffersFavorite: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: components["requestBodies"]["OfferIdPostBody"];
        responses: {
            /** @description Success */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: components["responses"]["Default400ErrorResponse"];
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    DeleteApiV2OffersFavorite: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: components["requestBodies"]["OfferIdPostBody"];
        responses: {
            /** @description Success */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: components["responses"]["Default400ErrorResponse"];
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisers: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdvertisersCollection"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Advertiser"];
                };
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAffiliateAdvertisersId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AffiliateAdvertiser"];
                };
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PatchApiAffiliateAdvertisersId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: components["requestBodies"]["AffiliateAdvertiserPatchBody"];
        responses: {
            /** @description Success */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersIdModels: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the offer */
                id: components["parameters"]["OfferId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModelsCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersIdAttributes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdvertiserAttributesCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersIdCountries: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdvertiserCountriesCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetOfferRule: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
                /** @description The name of the section */
                section: components["parameters"]["SectionId"];
                /** @description Locale information */
                locale: components["parameters"]["LocaleId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferRuleItem"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetOfferRules: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferRulesResponse"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiOffersLoyaltyLevels: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LoyaltyLevels"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
}
export enum ApiPaths {
    GetHealthcheck = "/healthcheck",
    GetApiModels = "/api/models",
    GetApiV2Offers = "/api/v2/offers",
    GetApiV2OffersAdvertModel = "/api/v2/offers/{AdvertModel}",
    GetApiV2OffersAdvertModelAdvertiser = "/api/v2/offers/{AdvertModel}/advertiser",
    GetApiV2OffersAdvertModelCpaRates = "/api/v2/offers/{AdvertModel}/cpa-rates",
    GetApiV2OffersAdvertModelCpaTriggers = "/api/v2/offers/{AdvertModel}/cpa-triggers",
    GetApiV2OffersAdvertModelRevenueRatedView = "/api/v2/offers/{AdvertModel}/revenue-rated-view",
    GetApiV2OffersAdvertModelActivation = "/api/v2/offers/{AdvertModel}/activation",
    GetApiV2OffersActivations = "/api/v2/offers/activations",
    PostApiV2OffersAdvertModelTrafficSources = "/api/v2/offers/{AdvertModel}/traffic-sources",
    PostApiV2OffersAdvertModelMarketingRulesAccept = "/api/v2/offers/{AdvertModel}/marketing-rules-accept",
    PostApiV2OffersFavorite = "/api/v2/offers/favorite",
    DeleteApiV2OffersFavorite = "/api/v2/offers/favorite",
    GetApiAdvertisers = "/api/advertisers",
    GetApiAdvertisersId = "/api/advertisers/{id}",
    GetApiAffiliateAdvertisersId = "/api/affiliate-advertisers/{id}",
    PatchApiAffiliateAdvertisersId = "/api/affiliate-advertisers/{id}",
    GetApiAdvertisersIdModels = "/api/advertisers/{id}/models",
    GetApiAdvertisersIdAttributes = "/api/advertisers/{id}/attributes",
    GetApiAdvertisersIdCountries = "/api/advertisers/{id}/countries",
    GetOfferRule = "/api/v2/offers/{AdvertModel}/rules/{section}/{locale}",
    GetOfferRules = "/api/v2/offers/{AdvertModel}/rules",
    GetApiOffersLoyaltyLevels = "/api/offers/loyalty-levels"
}
